// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3cFa4","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__6VMs9"};